import React, { useContext } from 'react';
import styled, { useTheme } from 'styled-components';
import { useField } from 'react-final-form';
import { required, startsWithCapital } from '@ubeya/shared/utils/form';
import { FlexSpace, CircleIcon, TimeField, InputField, SortableHandler } from '@ubeya/shared-web/components';
import { DEFAULT_START_TIME } from '@ubeya/shared/utils/time';
import { ReactComponent as DeleteIcon } from '@ubeya/shared-web/assets/close-big.svg';
import { media } from '@ubeya/shared-web/style';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { SortableElement } from 'react-sortable-hoc';
import { LocationSelectField } from 'shared/components';

const Container = styled(FlexSpace)`
  padding-bottom: 10px;
  > div:not(:last-child) {
    margin-right: 10px;
  }
`;

const WideInputField = styled(InputField)`
  flex: 2;
  > input {
    color: ${({ color }) => color};
    background: ${({ background }) => background};
  }
`;

const SmallTimeField = styled(TimeField)`
  width: 100%;
  ${media.mobile`
    max-width:125px;
  `}
`;

const Section = ({ section, name, onDelete, isSelected, colorIndex }) => {
  const { t } = useContext(ConfigContext);
  const theme = useTheme();

  const {
    input: { onChange: setLocationId }
  } = useField(`${name}.locationId`);

  return (
    <Container>
      <SortableHandler />
      <WideInputField
        name={`${name}.title`}
        validate={required}
        placeholder={t('sectionName')}
        onChange={startsWithCapital}
        color={section.id > 0 ? section?.color : theme.colors.palette[colorIndex % theme.colors.palette.length].dark}
        background={
          section.id > 0 ? section.background : theme.colors.palette[colorIndex % theme.colors.palette.length].light
        }
        autoFocus={isSelected}
      />

      <LocationSelectField name={`${name}.locationId`} title=" " onAdd={setLocationId} />
      <SmallTimeField name={`${name}.startTime`} timeOnly defaultValue={DEFAULT_START_TIME} usePortal />
      <SmallTimeField
        name={`${name}.endTime`}
        timeOnly
        defaultValue={DEFAULT_START_TIME}
        usePortal
        isDisabled={!section.startTime}
      />
      <CircleIcon icon={DeleteIcon} onClick={() => onDelete(section)} />
    </Container>
  );
};

export default SortableElement(Section);
